export const dynamicQuestions = [
  // Step 1: Select Dropdown
  { 
    id: 'genre', 
    type: 'select', 
    label: "Game Genre", 
    options: ['Obby', 'Tycoon', 'RPG', 'FPS', 'Simulator'] 
  },
  // Step 2: Number Input
  { 
    id: 'players', 
    type: 'number', 
    label: "Max Players", 
    placeholder: "e.g. 20" 
  },
  // Step 3: Text Area (Detailed)
  { 
    id: 'visuals', 
    type: 'textarea', 
    label: "Visual Style Description", 
    placeholder: "Describe the lighting, textures, and atmosphere..." 
  }
];

export const chatHistory = [
  { id: 1, role: 'user', content: "I want a sci-fi vehicle script.", image: null },
  { 
    id: 2, 
    role: 'ai', 
    content: "I've generated the base chassis. Here is a preview of the model structure.", 
    // Using a placeholder image for demo
    image: "https://placehold.co/600x400/1e293b/white?text=3D+Model+Preview" 
  },
  { id: 3, role: 'user', content: "Looks good, make it faster.", image: null },
];

export const processLogs = [
  { step: 'Init', status: 'done', msg: 'Environment loaded.' },
  { step: 'Analysis', status: 'done', msg: 'Request parsed.' },
  { step: 'Generation', status: 'processing', msg: 'Compiling Lua script...' },
];

// Mock Assets Data
export const projectAssets = [
  { id: 1, name: "HoverCar_Script", type: 'script', size: '12kb' },
  { id: 2, name: "SciFi_City_Map", type: 'model', size: '4.2mb' },
];
